import { Box, Flex, HStack, VStack } from '@chakra-ui/react';
import { Skeleton } from '@/components/ui/skeleton';
import React from 'react';
import { MENTION_AVATAR_SIZE, mentionCardFooterPadding } from './mentionCardStyle';

interface MentionCardSkeletonProps {
  /** Flat, dense variant for narrow contexts (the contact drawer). */
  compact?: boolean;
  /** Whether the creator identity sits in the footer, mirroring the card. */
  showCreator?: boolean;
  /** Media aspect ratio, mirrors the card it stands in for. */
  mediaAspectRatio?: string;
}

const MentionCardSkeleton: React.FC<MentionCardSkeletonProps> = ({
  compact = false,
  showCreator = true,
  mediaAspectRatio = '4/5',
}) => {
  return (
    <Box
      bg="panelBg"
      rounded={compact ? 'sm' : 'md'}
      overflow="hidden"
      border="1px solid"
      borderColor="border"
    >
      {/* Media placeholder */}
      <Box aspectRatio={mediaAspectRatio} width="100%" bg="softCream">
        <Skeleton height="100%" width="100%" />
      </Box>

      {/* Footer — single row, mirroring MentionCardFooter. Pill-shaped bars keep
          it soft and readable at the card's small footprint. */}
      <Flex alignItems="center" gap={2} {...mentionCardFooterPadding(compact)}>
        {showCreator ? (
          <Flex alignItems="center" gap={2} flex="1" minW={0}>
            <Skeleton
              height={MENTION_AVATAR_SIZE}
              width={MENTION_AVATAR_SIZE}
              rounded="full"
              flexShrink={0}
            />
            <VStack alignItems="flex-start" gap={1} flex={1} minW={0}>
              <Skeleton height="9px" width="72px" maxW="80%" rounded="full" />
              <Skeleton height="8px" width="46px" rounded="full" />
            </VStack>
          </Flex>
        ) : (
          <Skeleton height="9px" width="48px" rounded="full" />
        )}

        {/* Two metric placeholders (icon dot + number), mirroring MentionCardStats. */}
        <HStack gap={compact ? 2 : 2.5} ml="auto" flexShrink={0}>
          {Array.from({ length: 2 }).map((_, index) => (
            <HStack key={index} gap={1.5}>
              <Skeleton
                height={compact ? '12px' : '13px'}
                width={compact ? '12px' : '13px'}
                rounded="full"
              />
              <Skeleton height="8px" width={compact ? '16px' : '20px'} rounded="full" />
            </HStack>
          ))}
        </HStack>
      </Flex>
    </Box>
  );
};

export default MentionCardSkeleton;
